'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M128 768h768v192h-768v-192z' }),
        React.createElement('path', { d: 'M640 384v-320h-256v320h-224l352 352 352-352z' })
    ));
};